export default __webpack_public_path__ + "static/media/background-sample.7089bc5e.jpg";